import Layout from '@/components/layout/Layout';

const RefundPolicy = () => {
  return (
    <Layout>
      <section className="relative pt-8 pb-12 bg-background overflow-hidden min-h-screen">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px] z-0" />

        <div className="container-max max-w-4xl relative z-10 px-4">
          <span className="inline-block px-4 py-2 bg-accent/5 border border-accent/20 rounded-full text-accent-foreground text-[10px] font-black uppercase tracking-[0.2em] mb-8">
            Policy
          </span>
          <h1 className="text-2xl md:text-4xl font-black text-primary mb-12 tracking-tighter uppercase">Refund <br /><span className="text-gradient-gold">Policy</span></h1>

          <div className="card-premium !p-12 bg-white/40 border-white/60 backdrop-blur-xl">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tighter prose-p:text-muted-foreground prose-p:font-medium prose-p:leading-relaxed">
              <p className="text-sm font-black text-accent uppercase tracking-widest mb-12 pb-8 border-b border-gray-100">
                Last Updated: January 2024
              </p>

              <h2 className="text-2xl mb-6">Our Commitment</h2>
              <p>
                At Ratchagan Analysis, we are committed to providing high-quality stock market education. Our programs are designed to give you valuable insights and strategies once you join.
              </p>

              <h2 className="text-2xl mt-12 mb-6 text-red-600">No Refund Policy</h2>
              <p className="font-bold underline text-primary">
                Please note that we have a strict NO REFUND policy. Once you pay and get access to our course videos and lessons, no refunds will be given for any reason.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Why No Refunds?</h2>
              <p>
                Since our courses are digital and you get full access to all lessons right away, they cannot be returned or refunded. We suggest all students check the course details and talk to our team before buying.
              </p>

              <div className="mt-16 pt-12 border-t border-gray-100 italic">
                <p className="text-sm">
                  If you have any questions about this policy, please email us at{' '}
                  <a href="mailto:ratchagananalysis@gmail.com" className="text-accent font-bold hover:underline">
                    ratchagananalysis@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default RefundPolicy;
